module.exports = __webpack_public_path__ + "static/media/settings_ic.a9688ef5.svg";